module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-17-c7b09c94a7d5d79cfd62372910a8b15f.jpg";